const checkIfDefault = (value, defaultVal) => {
  if (!value) {
    return defaultVal;
  }
  if ((typeof value === 'string' || value instanceof String) && value.includes('#{REACT_APP_')) {
    return defaultVal;
  }
  return value;
};

const envConfig = {
  ApiUrl: process.env.REACT_APP_API_URL ?? checkIfDefault('https://solargen-api-hfbhfcgmfngzhhh5.eastus-01.azurewebsites.net/api', ''),
  ApiKey: process.env.REACT_APP_API_KEY ?? checkIfDefault('d8227a7b973547adad7e01a11f672f23', ''),
  StoragePrefix: process.env.REACT_APP_PREFIX ?? checkIfDefault('solargen', ''),
  DefaultLanguage: process.env.REACT_APP_DEFAULT_LANGUAGE ?? checkIfDefault('en', ''),
  ContactEmail: process.env.REACT_APP_CONTACT_EMAIL ?? checkIfDefault('hello@gopanza.com', ''),
  SupportEmail: process.env.REACT_APP_SUPPORT_EMAIL ?? checkIfDefault('hello@gopanza.com', ''),
  SiteTitle: process.env.REACT_APP_TITLE ?? checkIfDefault('Solar X', ''),
  SiteDescription: process.env.REACT_APP_DESCRIPTION ?? checkIfDefault('#{REACT_APP_DESCRIPTION}#', ''),
  TokenLifetimeHours: process.env.REACT_APP_TOKEN_LIFETIME_HOURS ?? checkIfDefault('12', '24'),
  EncryptionKey: process.env.REACT_APP_ENCRYPTION_KEY ?? checkIfDefault('#{REACT_APP_ENCRYPTION_KEY}#', ''),
  ServerConfigurationString: process.env.REACT_APP_SERVER_CONFIG_STRING ?? checkIfDefault('#{REACT_APP_SERVER_CONFIG_STRING}#', ''),
  GoogleApiKey: process.env.REACT_APP_GOOGLE_API_KEY ?? checkIfDefault('AIzaSyB6jl09IPMyXwc55wjIj40Mi9p2ABtZKf0', ''),
  OpenAIKey: process.env.REACT_APP_OPENAI_API_KEY ?? checkIfDefault('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', ''),
  // HideMenuLocations: ['/register', '/recover', '/reset', '/updatepass'],
  // HideHeaderLogo: ['/', '/register', '/recover', '/reset', '/updatepass'],
  Roles: [
    { index: 1, key: 'GlobalAdmin', name: 'global_admin' },
    { index: 2, key: 'Admin', name: 'admin' },
    { index: 3, key: 'CustomerSupport', name: 'customer_support' },
    { index: 8, key: 'OrganizationAdmin', name: 'organization_admin' },
    { index: 6, key: 'CloserAdmin', name: 'closer_admin' },
    { index: 4, key: 'CloserManager', name: 'closer_manager' },
    { index: 5, key: 'Closer', name: 'closer' },
    { index: 7, key: 'Setter', name: 'setter' },
    { index: 9, key: 'LeadManager', name: 'lead_manager' },
    { index: 10, key: 'EmailNotification', name: 'lead_email_notification' },
    { index: 11, key: 'LearningManager', name: 'learning_manager' },
    { index: 12, key: 'Learning', name: 'learning' },
  ],
  GraphColor: '#0c6ea7'
};

export default envConfig;
